import { Button, Layout, theme, Form, Select, Input, Spin, notification } from "antd";

import React, { useEffect, useState, useCallback } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import RuntimeConfigsApi from "../../common/Apis/RuntimeConfigsApi";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import styles

const EditTwilioConfigurations = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { Content } = Layout;
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);
  const [SelectValue, setSelectValue] = useState(null);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [editorHtml, setEditorHtml] = useState('');

  const handleChange = (html) => {
    setEditorHtml(html);
  };

  const getSingleStorage = useCallback(() => {
    RuntimeConfigsApi.SingleRuntimeConfigs(id)
      .then((response) => {
        form.setFieldsValue({
          configValue: response?.payload?.configValue,
          configValue2: response?.payload?.configValue,
          configKey: response?.payload?.configKey,
          activeFrom: dayjs(response?.payload?.activeFrom),
          activeTo: dayjs(response?.payload?.activeTo),
        });
        setSelectValue(response?.payload?.tag);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  useEffect(() => {
    getSingleStorage();
  }, [getSingleStorage]);




  const handleSubmit = (data) => {
    const activeFromN = convertToUnixTimestamp(data.activeFrom);
    const activeToN = convertToUnixTimestamp(data.activeTo);
    let formData = JSON.stringify({
      configValue: SelectValue === "PROTECTIVE_CLOTHING_CONFIG" ? data?.configValue2 : data?.configValue ,
      configKey: data?.configKey,
      tag: SelectValue,
      id: id,
      activeFrom: activeFromN,
      activeTo: activeToN,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    })

    RuntimeConfigsApi.PutRuntimeConfigs(id, formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Update Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        navigate(-1);
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

 function convertToUnixTimestamp(dateValue) {
  if (!dateValue) return null;

  if (typeof dateValue === "string") {
    const parts = dateValue.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    return Date.UTC(year, month, day);
  }

  return dateValue.startOf("day").valueOf();
}

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            form={form}
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>  <Col lg={10} md={12}>
                <Form.Item
                  name="configKey"
                  label="Config Key"
                  className="text-lable"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Config Key",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    readOnly
                    placeholder="Config Key"
                    className="control-input"
                  />
                </Form.Item>
              </Col>
              <Col lg={10} md={12}>
                  <Form.Item
                    name="configValue"
                    label="Config Value"
                    className={`${SelectValue === "CURRENCY_TYPE_CONFIG" ? 'text-lable' : 'd-none'}`}
                  >
                    <Select
                      className="control-Select mb-3"
                      placeholder="Select Currency"
                    >
                      <option value="€"> Euro</option>
                      <option value="$"> Dollar</option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="configValue"
                    label="Config Value"
                    className={`${SelectValue === "PROTECTIVE_CLOTHING_CONFIG" ? 'd-none' : ''}`}
                  >
                    <Input
                      type="text"
                      placeholder="Config Value"
                      className="control-input"
                    />
                  </Form.Item>
                 
                  
                </Col>
                <Col lg={24} md={12} className={`${SelectValue === "PROTECTIVE_CLOTHING_CONFIG" ? '' : 'd-none'}`}>
                 
                  <Form.Item
                    name="configValue2"
                    label="Config Value"
                  >
                     <ReactQuill
                      theme="snow" // or 'bubble' for a bubble theme
                      value={editorHtml}
                      style={{ height: '200px' }}
                      onChange={handleChange}
                    />
                  </Form.Item>
                  
                </Col>
              </Row>


              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Update {loadings === true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout >
  );
};
export default EditTwilioConfigurations;
